import { get } from 'lodash';
import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import withCountries from '../withCountries.graphql';
import useT from '../../components/utils/Translations/useT';
export default function useCountries() {
    const t = useT();
    const queryRes = useQuery(withCountries, { fetchPolicy: 'cache-first' });
    const countries = useMemo(() => get(queryRes, 'data.countries', []).map(({ name, ...rest }) => ({
        ...rest,
        name: t(name),
    })), [t, queryRes]);
    return { countries, error: queryRes.error, loading: queryRes.loading };
}
